import { ReturnStruct } from "src/app/shared/structs/return.struct";
import { CsatModel } from "../../models/csat/csat.model";

export class CsatRequest extends ReturnStruct {
    csat: CsatModel;
    showFloatingButton: boolean;
}